








































import { Vue, Component, Prop } from "vue-property-decorator";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";

@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class ConditionTableItem extends Vue {
  @Prop() condition!: ICondition;

  editHandler() {
    this.$router.push({
      name: "conditionEdit",
      params: { id: this.condition.id! }
    });
  }

  removeHandler() {
    this.$emit("remove", this.condition);
  }
}
